module.exports = __webpack_public_path__ + "img/cursorDefault.715fa278.png";